module.exports = __webpack_public_path__ + "img/watch.8eb5b8c9.png";